import jwtAuthAxios from 'app/services/auth/jwtAuth'

const classTypeServices = {}

classTypeServices.getClassTypeLookupList = async (filter) => {
    let url = filter?.classTypeName
        ? `/api/Setting/classType/lookup/list?search=${filter.classTypeName}`
        : `/api/Setting/classType/lookup/list`
    const { data } = await jwtAuthAxios.get(url, filter).catch(function (error) {
        if (error.response) {
            throw Error(error.response.data)
        } else if (error.request) {
            console.log(error.request)
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return data
}

classTypeServices.getClassTypeLookupById = async (key) => {
    let url = `/api/Setting/classType/lookup/${key}`
    const { data } = await jwtAuthAxios.get(url, '').catch(function (error) {
        if (error.response) {
            throw Error(error.response.data)
        } else if (error.request) {
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return data
}

export default classTypeServices
